<div class="offline-toolbar apd-dark-theme">
  <div class="title">{{ 'app.offlineToolbar.info' | translate }}</div>
  @if (online) {
    <div class="description">- {{ 'app.offlineToolbar.connected' | translate }}</div>
  }
  @if (!online) {
    <div class="description">- {{ 'app.offlineToolbar.disconnected' | translate }}</div>
  }
  <div class="status">
    <i class="material-icons">{{ online ? 'wifi' : 'wifi_off' }}</i>
  </div>
  <div class="description">{{ 'app.offlineToolbar.offlineChanges' | translate }}: {{ offlineChanges }}</div>
  <div class="description">
    <i class="material-icons" (click)="fetchPendingCount()">{{ 'autorenew' }}</i>
  </div>
  @if (online) {
    <div class="switchMode">
      <button mat-flat-button color="primary" (click)="switchToOnline()">
        {{ 'app.offlineToolbar.switchToOnline' | translate }}
      </button>
    </div>
  }
</div>
